import React from 'react';

interface TorahScrollArtProps {
  className?: string;
}

/** Decorative line drawing of an open Torah scroll (watermark on the pasuk card). */
const TorahScrollArt: React.FC<TorahScrollArtProps> = ({ className = '' }) => (
  <svg
    viewBox="0 0 220 200"
    fill="none"
    stroke="currentColor"
    strokeWidth={5}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    className={className}
  >
    {/* back roller */}
    <path d="M150 6v16M140 22h20M146 22v150M154 22v150M140 172h20M150 172v16" />
    <rect x="132" y="40" width="36" height="112" rx="18" />
    {/* front roller */}
    <path d="M70 46v14M60 60h20M66 60v130M74 60v130" />
    <rect x="50" y="78" width="40" height="104" rx="20" />
    {/* sheet between the rollers */}
    <path d="M90 92c14-6 28-6 42-2M90 168c14 4 28 4 42-2" />
    <path d="M100 112h24M100 126h24M100 140h18" />
  </svg>
);

export default TorahScrollArt;
